import Controller, { OnChange, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { FetchAPI, FieldAPI } from '@philips-internal/oswald-ui-components';
import { ChangeEvent, MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { getFoundationDataContext } from '../../app/bootstrap-foundation';
import { FragmentNames, PseudonymAppointmentsStep_5Aliases } from '../../codegen';
import PseudonymAppointmentsBaseController from './pseudonym-appointments-base-controller';
import PseudonymAppointmentModel from './pseudonym-appointments-model';
import { EstablishmentGroupLocalizationModel } from './pseudonym-interfaces';
import { AppointmentsSteps, REQUIREMENT_FIELDS } from './pseudonym-types';
import AppointmentService from '../../services/appointment-service';
import { Inject } from '@odinjs/odin';

@Controller({ component: PseudonymAppointmentsStep_5Aliases.LAYOUT_LOCATION, fragment: FragmentNames.PSEUDONYM_APPOINTMENTS_STEP_5 })
export default class PseudonymAppointmentsStep5Controller extends PseudonymAppointmentsBaseController {

  @Inject(PseudonymAppointmentsStep_5Aliases.FETCH_LOCATION)
    fetchLocationApi!: FetchAPI;

  @OnMount({ target: PseudonymAppointmentsStep_5Aliases.LAYOUT_LOCATION })
  handleMountLocation(): void {
    PseudonymAppointmentModel.stepFive.loadLocation = () => this.loadLocation(PseudonymAppointmentModel.stepOne.healthInsurance.healthInsuranceId);
  }

  loadLocation(healthInsuranceID: number): void {
    const applicationContext = getFoundationDataContext();
    applicationContext.set({ isLocationStepDone: false });
    this.fetchLocationApi.setParameters({ cdConvenio: healthInsuranceID });
    this.fetchLocationApi.forceFetch();
  }

  @OnChange({ target: PseudonymAppointmentsStep_5Aliases.FIELD_LOCATION })
  onChangeFieldLocation(event: ChangeEvent<EstablishmentGroupLocalizationModel>): void {
    if (event) {
      PseudonymAppointmentModel.stepFive.location = event.value;
    }
    const applicationContext = getFoundationDataContext();
    const isLocationRequired = applicationContext.get(REQUIREMENT_FIELDS.LOCATION_REQUIRED);
    if (isLocationRequired) {
      const isLocationStepDone = event.value != undefined;
      this.setWizardStepDone(AppointmentsSteps.STEP_5_LOCATION, isLocationStepDone);
      applicationContext.set({ isLocationStepDone });
    }
  }

  @OnMount({target: PseudonymAppointmentsStep_5Aliases.FIELD_LOCATION})
  handleLocationFieldStep(event: MountEvent): void {
    const locationField = event.target as FieldAPI;
    const applicationContext = getFoundationDataContext();
    AppointmentService.getAppointmentFieldLocation(locationField).then(isLocationRequired => {
      applicationContext.set({ isLocationRequired });
    });
  }
}
